


import {
    IStillImageBackgroundConfig,
    StillImageBackground
} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TimelineMax, TweenMax} from "gsap";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {LeParticlesManager} from "../utils/LeParticlesManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {HarlequinGameConfig} from "../HarlequinGameConfig";

export class HarlequinBackground extends StillImageBackground {


    public static emberParticleConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 0.8
        },
        "scale" : {
            "start" : 0.8,
            "end" : 0.8,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffd151",
            "end" : "#d19600"
        },
        "speed" : {
            "start" : 90,
            "end" : 0,
            "minimumSpeedMultiplier" : 0.5
        },
        "acceleration" : {
            "x" : 2,
            "y" : 1
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -150,
            "max" : -130
        },
        "noRotation" : true,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 0
        },
        "lifetime" : {
            "min" : 25,
            "max" : 35
        },
        "blendMode" : "add",
        "frequency" : 1.25,
        "emitterLifetime" : -1,
        "maxParticles" : 5,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -200,
            "y" : 780,
            "w" : 800,
            "h" : 0
        }
    };

    public static emberParticleConfigRev:any = {
        "alpha" : {
            "start" : 1,
            "end" : 0.8
        },
        "scale" : {
            "start" : 0.8,
            "end" : 0.8,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffd151",
            "end" : "#d19600"
        },
        "speed" : {
            "start" : 90,
            "end" : 0,
            "minimumSpeedMultiplier" : 0.5
        },
        "acceleration" : {
            "x" : -4,
            "y" : 1
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -75,
            "max" : -65
        },
        "noRotation" : true,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 0
        },
        "lifetime" : {
            "min" : 25,
            "max" : 35
        },
        "blendMode" : "add",
        "frequency" : 1.25,
        "emitterLifetime" : -1,
        "maxParticles" : 5,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 720,
            "y" : 780,
            "w" : 800,
            "h" : 0
        }
    };

    private _emitters: Emitter [] = [];

    private _bgSprite:PIXI.Sprite;
    private _bgSpine:PIXI.spine.Spine;
    private _animList:string [] = [
        "animation",
        "basegame",
        "bonusGame",
        "nearWinScatter",
        "respin",
        "winInitial",
        "winTogel"
    ];

    private _hueTimeline:TimelineMax;

    private _blueLayer:ScalableLayer;
    private _redLayer:ScalableLayer;
    private _greenLayer:ScalableLayer;

    constructor(config:IStillImageBackgroundConfig) {
        super(config);

        this._blueLayer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.BLUE_BACKGROUND.name);
        this._redLayer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.RED_BACKGROUND.name);
        this._greenLayer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.GREEN_BACKGROUND.name);
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation == Orientation.PORTRAIT) {

            this.scale.set(1, 1);
            this._backgroundSprite!.position.set(-480, -468); // TODO: dynamics migh be better
            this._bgSprite!.position.set(360, 370);
        }
        else {
            //console.log(resizeData);
            this.scale.set(0.88, 0.88);
            this._backgroundSprite!.position.set(-445, -340); // TODO: dynamics migh be better
            this._bgSprite!.position.set(398, 507);
        }

    }

    private tmpDebugHandler():void {
        const ref = this;
        let headCntr:number = 0;
        const animations:string [] = [
            "animation",
            "basegame",
            "bonusGame",
            "nearWinScatter",
            "respin",
            "winInitial",
            "winTogel"
        ];

        document.addEventListener("keydown", function(e) {
            var keyCode = e.keyCode;
            //console.log("KeyCode: " + keyCode);

            switch(keyCode) {
                case 56:
                    let hstr:string= "";

                    if(headCntr === animations.length) {
                        headCntr = 0;
                    }
                    else {
                        // headSpine
                        ref._bgSpine.state.setAnimation(0, hstr = animations[headCntr++], false);
                    }

                    console.log("PLAYING: " + hstr);
                    break; // 8
            }
        }, false);
    }

    initAnimations():void {
        super.initAnimations();

        this.createSpine();
        this.createBgParticles();
        //this.tmpDebugHandler();
    }

    public hideParticles():void {
        this._hueTimeline.pause();

        this._emitters.forEach((emitter) => {
            emitter.emit = false;
        });
    }

    public showParticles():void {
        this._hueTimeline.play();

        this._emitters.forEach((emitter) => {
            emitter.emit = true;
        });
    }

    protected createBgParticles():void {
        const yellowEmbers:PIXI.Sprite [] = [];
        //const blueEmbers:PIXI.Sprite [] = [];
       // const redEmbers:PIXI.Sprite [] = [];
       // const greenEmbers:PIXI.Sprite [] = [];

        const blueTextures:PIXI.Texture [] = [];

        [0, 1, 2].forEach((value) => {
            yellowEmbers.push(new PIXI.Sprite(GameResources.getTextures("ember"+value)[0]));
            //blueEmbers.push(new PIXI.Sprite(GameResources.getTextures("ember"+value)[0]));
            //redEmbers.push(new PIXI.Sprite(GameResources.getTextures("ember"+value)[0]));
            //greenEmbers.push(new PIXI.Sprite(GameResources.getTextures("ember"+value)[0]));

            //blueTextures.push(blueEmbers[value].texture);

            const colorMatrixRed = new PIXI.filters.ColorMatrixFilter();
            colorMatrixRed.hue(-60 + (value * 5), false);
            //redEmbers[value].filters = [colorMatrixRed];

            const colorMatrixGreen = new PIXI.filters.ColorMatrixFilter();
            colorMatrixGreen.hue(50 + (value * 5), false);
            //greenEmbers[value].filters = [colorMatrixGreen];
        });
        //yellowEmbers[0].position.set(-100, -100);

        const colorMatrixBlue = new PIXI.filters.ColorMatrixFilter();
        colorMatrixBlue.hue(150, false);
        this._blueLayer.filters = [colorMatrixBlue];

        const colorMatrixRed = new PIXI.filters.ColorMatrixFilter();
        colorMatrixRed.hue(-60, false);
        this._redLayer.filters = [colorMatrixRed];

        const colorMatrixGreen = new PIXI.filters.ColorMatrixFilter();
        colorMatrixGreen.hue(50, false);
        this._greenLayer.filters = [colorMatrixGreen];

        const emitter:Emitter = new Emitter(this._layer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : yellowEmbers
        }], HarlequinBackground.emberParticleConfig);
        emitter.particleConstructor = AnimatedParticle;
        LeParticlesManager.addEmitter(emitter, false);
        this._emitters.push(emitter);

        const blueEmitter:Emitter = new Emitter(this._blueLayer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : yellowEmbers
        }], HarlequinBackground.emberParticleConfig);
        blueEmitter.particleConstructor = AnimatedParticle;
        LeParticlesManager.addEmitter(blueEmitter, false);
        this._emitters.push(blueEmitter);

        const greenEmitter:Emitter = new Emitter(this._greenLayer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : yellowEmbers
        }], HarlequinBackground.emberParticleConfig);
        greenEmitter.particleConstructor = AnimatedParticle;
        LeParticlesManager.addEmitter(greenEmitter, false);
        this._emitters.push(greenEmitter);

        const redEmitter:Emitter = new Emitter(this._redLayer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : yellowEmbers
        }], HarlequinBackground.emberParticleConfig);
        redEmitter.particleConstructor = AnimatedParticle;
        LeParticlesManager.addEmitter(redEmitter, false);
        this._emitters.push(redEmitter);
        //this._coinsEmitters.push(emitter);

        const emitterRev:Emitter = new Emitter(this._layer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : yellowEmbers
        }], HarlequinBackground.emberParticleConfigRev);
        emitterRev.particleConstructor = AnimatedParticle;
        LeParticlesManager.addEmitter(emitterRev, false);
        this._emitters.push(emitterRev);

        const blueEmitterRev:Emitter = new Emitter(this._blueLayer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : yellowEmbers
        }], HarlequinBackground.emberParticleConfigRev);
        blueEmitterRev.particleConstructor = AnimatedParticle;
        LeParticlesManager.addEmitter(blueEmitterRev, false);
        this._emitters.push(blueEmitterRev);

        const greenEmitterRev:Emitter = new Emitter(this._greenLayer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : yellowEmbers
        }], HarlequinBackground.emberParticleConfigRev);
        greenEmitterRev.particleConstructor = AnimatedParticle;
        LeParticlesManager.addEmitter(greenEmitterRev, false);
        this._emitters.push(greenEmitterRev);

        const redEmitterRev:Emitter = new Emitter(this._redLayer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : yellowEmbers
        }], HarlequinBackground.emberParticleConfigRev);
        redEmitterRev.particleConstructor = AnimatedParticle;
        LeParticlesManager.addEmitter(redEmitterRev, false);
        this._emitters.push(redEmitterRev);

        this._hueTimeline = new TimelineMax({
            paused: true,
            repeat: -1
        });

        let bcntr:number = 150;
        let rcntr:number = 60;
        let gcntr:number = 50;
        this._hueTimeline.add(() => {
            if(rcntr > -45) {
                rcntr = -60;
            }

            if(bcntr > 165) {
                bcntr = 150;
            }

            if(gcntr > 65) {
                bcntr = 50;
            }

            colorMatrixGreen.hue(gcntr++, false);
            colorMatrixBlue.hue(bcntr++, false);
            colorMatrixRed.hue(rcntr++, false);
        }, 0.066);

    }

    /*
    *Animations:
    * 0: Animation {name: "animation", timelines: Array(0), duration: 0}
        1: Animation {name: "basegame", timelines: Array(0), duration: 0}
        2: Animation {name: "bonusGame", timelines: Array(2), duration: 0}
        3: Animation {name: "nearWinScatter", timelines: Array(1), duration: 0}
        4: Animation {name: "respin", timelines: Array(2), duration: 0}
        5: Animation {name: "winInitial", timelines: Array(2), duration: 0}
        6: Animation {name: "winTogel", timelines: Array(3), duration: 0}
    *
    */
    createSpine():void {
        const bg = this._bgSprite = new PIXI.Sprite();
        //bg.anchor.set(0.5, 0.5);
        //bg.scale.set(0.7, 0.7);
        const spine = this._bgSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("backgroundSpine"));
        spine.state.setAnimation(0, "basegame", true);
        //console.log(spine.skeleton.data.animations);

        spine.stateData.setMix("basegame", "respin", 0.2);
        spine.stateData.setMix("respin", "basegame", 0.2);
        spine.stateData.setMix("basegame", "winInitial", 0.2);
        spine.stateData.setMix("winInitial", "respin", 0.2);
        spine.stateData.setMix("winInitial", "basegame", 0.2);
        spine.stateData.setMix("winInitial", "winTogel", 0.2);
        spine.stateData.setMix("winTogel", "basegame", 0.2);

        spine.stateData.setMix("basegame", "bonusGame", 0.2);
        spine.stateData.setMix("bonusGame","basegame",  0.2);
        spine.stateData.setMix("respin", "bonusGame", 0.2);
        spine.stateData.setMix("respin", "basegame", 0.4);

        bg.addChild(spine);

        this.addChild(bg);
    }

    public playBgSpine(name:string):void {
        if(this._animList.indexOf(name) > -1) {
            if(name === "winInitial" || name == "winTogel") {
                return;
            }

            this._bgSpine.state.setAnimation(0, name, true);

            if(name === "respin" || name === "bonusGame") {
                this.showParticles();
            }
            if(name === "basegame") {
                this.hideParticles();
            }
        }
    }

    protected onChangeBackground(data:IGameModeChangedData):boolean {

        const texture:PIXI.Texture = PIXI.Texture.WHITE;
        const scale:number = 0;
        this._backgroundSprite.texture = texture;this._backgroundSprite.scale.set(scale, scale);


        return true;
    }

}